import Vue from 'vue';
import Component from 'vue-class-component';
import { ModelSync, Prop } from 'vue-property-decorator';
import './breadcrumb.component.scss';
import { Breadcrumb } from '@/common/model/breadcrumb.model';
import { namespace } from 'vuex-class';
import { SortStoreConst } from '@/tsort/store/sort.store';
import { WorkInstruction } from '@/tsort/enum/work-instruction.enum';
import { WorkTypeSorting } from '@/tsort/enum/work-type-sorting.enum';
import { TaskTypeSorting } from '@/tsort/enum/task-type-sorting.enum';
import AppConstants from '@/common/constants/app.constants';
import NumberUtils from '@/common/utils/number.util';
import { SettingStoreConst } from '@/common/store/setting.store';
import SortingService from '@/tsort/service/sorting.service';
import SettingService from '@/common/service/setting.service';
import RouterUtils from '@/common/utils/router.util';
import FlashMessage from '../flash-message.component';
import ErrorCdMsgConstants from '@/common/constants/error-cd-msg.constants';
import { ScanSystemMenuResponse } from '@/tsort/model/response/scan-system-menu-response.model';
import CommonUtil from '@/common/utils/common.util';
import SortingUtils from '@/common/utils/sorting.util';
import { ScanSettingResponse } from '@/tsort/model/response/scan-setting-response.model';

const SettingStore = namespace(SettingStoreConst.SETTING_STORE_MODULE_NAME);
const SortStore = namespace(SortStoreConst.SORT_STORE_MODULE_NAME);
@Component({})
export default class BreadcrumbComponent extends Vue {
  @ModelSync('breadcrumbs', 'change') breadCrumbList!: Array<Breadcrumb>;
  @Prop({ type: String }) titleJP!: string;
  @Prop({ type: String }) titleEN!: string;
  @Prop({ default: false, type: Boolean }) isLargeTitle!: boolean;

  @SortStore.Getter
  workInstruction!: WorkInstruction;

  @SortStore.Getter
  workTypeSorting!: WorkTypeSorting;

  @SortStore.Getter
  taskTypeSorting!: TaskTypeSorting;

  @SortStore.Getter
  taskTypeName!: string;

  @SortStore.Getter
  rfidModeScanTarget!: number;

  @SettingStore.Action
  updateInductionId!: (value: string) => void;

  @SettingStore.Action
  updateInductionName!: (value: string) => void;

  @SettingStore.Action
  updateDeviceId!: (value: string) => void;

  @SortStore.Action
  updateWorkTypeSorting!: (value: WorkTypeSorting | string) => void;

  @SortStore.Action
  resetTaskTypeInfo!: () => void;

  @SortStore.Action
  updateScanSystemMenu!: (value: ScanSystemMenuResponse) => void;

  @SortStore.Action
  updateWesNo!: (value: number) => void;

  @SortStore.Action
  updateLastChuteNo!: (value: string) => void;

  @SortStore.Action
  updateRejectedTask!: (value: boolean) => void;

  @SortStore.Action
  updateRFIDModeScanTarget!: (value: number) => void;

  @SortStore.Action
  updateScanSetting!: (value: ScanSettingResponse) => void;

  @SettingStore.Getter
  externalDeviceId!: string;

  goTo(name: string) {
    this.$router.replace({ name: name });
  }

  // 画面表示されるボタン名
  buttonLabelDisplay = '単一まとめ切替';
  // 単一、まとめでボタンラベルを変更する際は以下を変更
  buttonLabelSingle = '単一まとめ切替';
  buttonLabelMulti = '単一まとめ切替';
  changeLabel(newLabel: string) {
    this.buttonLabelDisplay = newLabel;
  }

  settingService = new SettingService();
  sortingService = new SortingService();

  workMode = NumberUtils.parseInt(localStorage.getItem(AppConstants.STORAGE_WORK_MODE));

  listTextWorkType = [
    { value: WorkTypeSorting.SINGLE_SORTING, text: '単一投入' },
    { value: WorkTypeSorting.MULTI_SORTING, text: 'まとめ投入' },
    { value: WorkTypeSorting.MANUAL_SORTING, text: '手仕分け' }
  ];

  async onClickMinStepModeChange() {
    // 遷移先情報を変数として保持
    let targetPage = SortingUtils.isParallelSorting
      ? AppConstants.NAME_SINGLE_SORTING_PAGE
      : AppConstants.NAME_NO_TASK_SINGLE_SORTING_PAGE;
    let targetWorkType = WorkTypeSorting.SINGLE_SORTING;

    // 遷移先判定
    if (SortingUtils.isSingleSorting) {
      // 単一投入を開いていた場合、まとめ投入に切替
      targetPage = SortingUtils.isParallelSorting
        ? AppConstants.NAME_MULTI_SORTING_PAGE
        : AppConstants.NAME_NO_TASK_MULTI_SORTING_PAGE;
      targetWorkType = WorkTypeSorting.MULTI_SORTING;
      this.changeLabel(this.buttonLabelMulti);
    } else if (SortingUtils.isMultiSorting) {
      // まとめ投入を開いていた場合、単一投入に切替
      this.changeLabel(this.buttonLabelSingle);
    }
    // API実行
    const listScanSystemMenuDataResponse = await this.sortingService.getScanSystemField();
    const scanSystemMenuData = SortingUtils.filterListByCondition<ScanSystemMenuResponse>(
      listScanSystemMenuDataResponse,
      {
        taskType: this.taskTypeSorting,
        displayFlag: AppConstants.DISPLAY_FLAG_ON,
        workInstruction: this.workInstruction,
        workType: (workType: WorkTypeSorting) => workType !== WorkTypeSorting.MANUAL_SORTING
      }
    );

    // 切替可否チェック
    if (scanSystemMenuData.length === 0) {
      this.resetTaskTypeInfo();
      await RouterUtils.replaceRouterName(AppConstants.NAME_TOP_PAGE);
      this.showErrorMsgUnchangeable();
    } else {
      // 対象の作業タイプが存在しているか確認して
      this.$store.commit('setSwitchingBtnMode', false);
      const scanSystemMenuByTargetWorkType = scanSystemMenuData.filter((item) => item.workType === targetWorkType);
      if (scanSystemMenuByTargetWorkType.length === 0) {
        // 切替不可の場合、エラーメッセージ表示
        this.showErrorMsgUnchangeable();
        CommonUtil.playErrorSound();
        this.updateScanSystemMenu(scanSystemMenuData[0]);
      } else {
        // 対象のタスクタイプに複数のメニューがある場合、対象ページに移動します
        // scanSystemMenuDataの長さが2であれば、対象のタスクタイプはシングルおよびマルチソートの両方を持っていることを意味し、切り替えボタンが表示されます
        if (scanSystemMenuData.length === 2) {
          // setSwitchingBtnModeがtrueの場合、切替ボタンを表示します
          this.$store.commit('setSwitchingBtnMode', true);
        }
        // setChangeWorkTypeModeがtrueの場合、ルーターで処理しないようにします
        this.$store.commit('setChangeWorkTypeMode', true);
        // 目標ページに移動する
        await RouterUtils.replaceRouterName(targetPage);
        // ストレージ内のデータを更新する
        if (targetPage === this.$route.name) {
          this.updateScanSystemMenu(scanSystemMenuByTargetWorkType[0]);
          this.updateWorkTypeSorting(targetWorkType);
        }
        this.updateWesNo(0);
        this.updateLastChuteNo('');
        this.updateRejectedTask(false);
        this.$store.commit('setChangeWorkTypeMode', false);
      }
    }
  }

  /**
   * 単一まとめ切替ボタンの表示制御。
   */
  get switchingBtnMode() {
    return this.$store.getters.getSwitchingBtnMode;
  }

  /**
   * メソッドは変更不可のエラーメッセージを表示します。
   */
  showErrorMsgUnchangeable() {
    FlashMessage.getInstance().showErrorMsgWithErrorCode(
      ErrorCdMsgConstants.FUNC_SELECT_MODE_UNCHANGEABLE_ERR_CD,
      ErrorCdMsgConstants.FUNC_SELECT_MODE_UNCHANGEABLE_ERR_MSG
    );
  }

  render() {
    return (
      <div class="row">
        <div
          class="col-auto px-0 d-flex flex-row justify-content-end align-items-center"
          onClick={(_e: Event) => this.onClickBackIcon(_e)}
        >
          <span class="icon icon-arrow-back-svg cursor-pointer"></span>
        </div>
        <div class="col-auto d-flex align-items-center d-flex mr-4 pr-4">
          <div class="row text-gray1 font-weight-bold">{this.getBreadcrumbHTML()}</div>
        </div>
        {this.breadCrumbList.length > 2 && this.workMode === AppConstants.WORK_MODE_T_SORT ? (
          <div class="col ml-auto d-flex justify-content-end align-items-center pr-4">
            <div class="row flex-row-reverse breadcrumb-row">
              {this.switchingBtnMode ? (
                <div class="scan-change-btn-blue-sm">
                  <button
                    onClick={() => {
                      this.onClickMinStepModeChange();
                    }}
                  >
                    {this.buttonLabelDisplay}
                  </button>
                </div>
              ) : null}
              <div class="scan-btn-blue-sm">
                <button
                  onClick={() => {
                    this.goTo('Model Selection');
                  }}
                >
                  モード変更
                </button>
              </div>
              <div class="d-flex flex-row align-items-center breadcrumb-title">
                <span class={`icon icon-work-instruction-small-svg-${this.workInstruction}`}> </span>
                <span class="font-weight-bold work-instruction-title">
                  {SortingUtils.isParallelSorting ? '作業指示あり' : '作業指示なし'}&nbsp;/ &nbsp;
                </span>
                <span class={`icon icon-sorter-small-svg-${this.workTypeSorting}`}></span>
                {this.listTextWorkType
                  .filter((item) => item.value === this.workTypeSorting)
                  .map((item) => {
                    return <span class="font-weight-bold work-type-title">&nbsp;{item.text}&nbsp;/&nbsp;</span>;
                  })}
                <span class="font-weight-bold task-type-name-title">{this.taskTypeName} &nbsp;</span>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  onClickBackIcon(_e: Event) {
    if (window.location.href.indexOf('/mode-selection/') !== -1) {
      this.$router.replace({ name: 'TOP' });
      return;
    }
    const lastBreadcrumb = this.breadCrumbList[this.breadCrumbList.length - 1];
    this.onClickBreadcrumb(_e, lastBreadcrumb);
  }

  getBreadcrumbHTML() {
    const lastBreadcrumb = this.breadCrumbList[this.breadCrumbList.length - 1];
    const showIcon = (
      <div class="row d-flex align-items-center no-gutters">
        <div class="col-auto">
          <div class="row d-flex align-items-center no-gutters">
            <div class="col-auto align-items-center justify-content-center mr-2">
              <span class={`icon ${lastBreadcrumb.icon}`}></span>
            </div>
            <div class="col d-flex flex-column align-items-center position-relative">
              <span class="align-title">
                <strong class="text-size-setting">{lastBreadcrumb.parentText1}</strong>
                <strong class="algin-parentText2">{lastBreadcrumb.parentText2}</strong>
              </span>
            </div>
          </div>
        </div>
      </div>
    );

    return this.breadCrumbList.map((breadcrumb, index) => {
      const breadcrumbEle = (
        <span
          class="d-flex align-items-start align-breadcrumb cursor-pointer text-size-14"
          onClick={(e: Event) => this.onClickBreadcrumb(e, this.breadCrumbList[index])}
        >
          {breadcrumb.text}
        </span>
      );

      if (index === 0) {
        return;
      }
      if (index === 1) {
        if (window.location.href.indexOf(AppConstants.PATH_TO_SETTING_PAGE) !== -1) {
          return [
            <div class="row d-flex align-items-center no-gutters">
              <div class="col-auto">
                <div class="row d-flex align-items-center no-gutters">
                  <div class="col-auto">
                    <span class="icon icon-setting-svg ml-1"></span>
                  </div>
                  <div class="col d-flex flex-row align-items-center ">
                    <strong class="text-size-setting font-weight-bold pl-2">{lastBreadcrumb.parentText1}</strong>
                    <span class="pl-2 font-weight-normal text-dark text-size-14">Settings</span>
                  </div>
                </div>
              </div>
            </div>,
            <span class="align-text-setting">
              <span class="text-setting">{lastBreadcrumb.parentText2}</span>
            </span>
          ];
        }
        return [showIcon, breadcrumbEle];
      }
      const breadcrumbForwardSlash =
        window.location.href.indexOf(AppConstants.PATH_TO_SETTING_PAGE) === -1 ? (
          <span class="margin-top-slash">/</span>
        ) : null;
      return [breadcrumbForwardSlash, breadcrumbEle];
    });
  }

  onClickBreadcrumb(e: Event, breadcrumb: Breadcrumb) {
    e.preventDefault();
    let link = breadcrumb.link;
    const lastBreadcrumbItemIndex = link.lastIndexOf('/');
    if (lastBreadcrumbItemIndex !== -1) {
      link = link.substring(0, lastBreadcrumbItemIndex);
    }
    this.$router.push(link);
  }
}
